import { render } from "./PayMethodIcon.vue?vue&type=template&id=22ee2c9f&ts=true"
import script from "./PayMethodIcon.vue?vue&type=script&lang=ts"
export * from "./PayMethodIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__